import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import AgeGate from "@/components/AgeGate";
import Landing from "@/pages/Landing";
import ProviderJoin from "@/pages/ProviderJoin";
import ClientJoin from "@/pages/ClientJoin";
import SignIn from "@/pages/SignIn";
import Terms from "@/pages/Terms";
import Privacy from "@/pages/Privacy";
import Membership from "@/pages/Membership";
import Boutique from "@/pages/Boutique";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let frame;
    const raf = (time) => {
      lenis.raf(time);
      frame = requestAnimationFrame(raf);
    };
    frame = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(frame);
      lenis.destroy();
    };
  }, []);

  return (
    <BrowserRouter>
      <AgeGate />
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/join/provider" element={<ProviderJoin />} />
        <Route path="/join/client" element={<ClientJoin />} />
        <Route path="/signin" element={<SignIn />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/membership" element={<Membership />} />
        <Route path="/boutique" element={<Boutique />} />
        <Route path="/payment/success" element={<PaymentSuccess />} />
        <Route path="/payment/cancel" element={<PaymentCancel />} />
      </Routes>
      <Toaster theme="dark" position="bottom-right" />
    </BrowserRouter>
  );
}

export default App;
